/* gr.js — Grappler landing page JS. Reuses sk2.js for shared behavior. */

(function () {
  /* header.liquid's --header-height only covers the <header> element,
     missing the announcement bar + utility nav stacked above it.
     --gr-hero-top-offset captures the hero wrapper's true document-top
     so gr.css can size the hero to the visible area. */
  var wrapperEl = null;
  var rootStyle = document.documentElement.style;
  var lastOffset = -1;
  var rafId = 0;

  function measureTopOffset() {
    rafId = 0;
    if (!wrapperEl) wrapperEl = document.querySelector('.sk2-hero-wrapper');
    if (!wrapperEl) return;
    var top = wrapperEl.getBoundingClientRect().top + window.scrollY;
    if (top === lastOffset) return;
    lastOffset = top;
    rootStyle.setProperty('--gr-hero-top-offset', top + 'px');
  }

  function scheduleTopOffset() {
    if (rafId) return;
    rafId = requestAnimationFrame(measureTopOffset);
  }

  /* Wordmark: tagline words fade+slide up one at a time, tied to scroll.
     Once the last tagline word lands, the paragraph auto-plays ONCE
     (time-driven, not scroll-tied): its container grows from max-height 0
     to content-height, pushing the tagline upward as flex recenters,
     while each word inside fades in sequentially. */
  function initWordmark() {
    var section = document.querySelector('[data-gr-wordmark]');
    if (!section) return;

    var tagWords = section.querySelectorAll('[data-gr-tagline-word]');
    var paragraph = section.querySelector('[data-sk2-wm-paragraph]');
    var paraWords = paragraph ? paragraph.querySelectorAll('.sk2-wordmark__pword') : [];

    var tagLitCount = -1;
    var near = false;
    var ticking = false;
    var paraPlayed = false;
    var paraTimers = [];

    function resetParagraph() {
      paraPlayed = false;
      paraTimers.forEach(clearTimeout);
      paraTimers = [];
      if (paragraph) {
        paragraph.classList.remove('is-playing');
        paragraph.style.maxHeight = '';
      }
      paraWords.forEach(function (w) { w.classList.remove('is-lit'); });
    }

    function playParagraph() {
      if (paraPlayed || !paragraph) return;
      paraPlayed = true;
      paragraph.style.maxHeight = paragraph.scrollHeight + 'px';
      paragraph.classList.add('is-playing');
      /* Container fades in first (dark-gray text visible as a block); then
         words pop to white sequentially. */
      var wordStart = 900;
      var perWord = 45;
      paraWords.forEach(function (word, i) {
        var id = setTimeout(function () { word.classList.add('is-lit'); }, wordStart + i * perWord);
        paraTimers.push(id);
      });
    }

    function update() {
      ticking = false;
      if (!near) return;
      var rect = section.getBoundingClientRect();
      var ih = window.innerHeight;
      var animStart = -ih * 0.75;
      var animEnd = -(section.offsetHeight - ih * 1.1);
      var progress = Math.max(0, Math.min(1, (rect.top - animStart) / (animEnd - animStart)));

      /* Tagline uses 70% of scroll budget — the remaining 30% is just
         enough to let the paragraph auto-play before the section unsticks. */
      var tagProgress = Math.min(1, progress / 0.7);

      if (tagWords.length) {
        var tagCount = Math.floor(tagProgress * tagWords.length + 0.0001);
        if (tagCount !== tagLitCount) {
          for (var i = 0; i < tagWords.length; i++) {
            tagWords[i].classList.toggle('is-lit', i < tagCount);
          }
          tagLitCount = tagCount;
          section.classList.toggle('is-started', tagCount > 0);
          if (tagCount === 0 && paraPlayed) resetParagraph();
        }
        if (tagCount >= tagWords.length) playParagraph();
      }
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    new IntersectionObserver(function (entries) {
      near = entries[0].isIntersecting;
    }, { rootMargin: '200px 0px' }).observe(section);

    var initRect = section.getBoundingClientRect();
    near = initRect.bottom > -200 && initRect.top < window.innerHeight + 200;
    update();

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () {
      schedule();
      /* Re-set max-height if already played — content may reflow. */
      if (paraPlayed && paragraph) paragraph.style.maxHeight = paragraph.scrollHeight + 'px';
    }, { passive: true });

    var launchBtn = section.querySelector('[data-gr-wm-launch]');
    var modal = section.querySelector('[data-gr-wm-modal]');
    var videoHost = section.querySelector('[data-gr-wm-video]');
    var bgVideo = section.querySelector('video.sk2-wordmark__video');
    if (launchBtn && modal && videoHost) {
      var ytId = videoHost.getAttribute('data-yt');
      function openModal() {
        if (!ytId) return;
        if (bgVideo) { try { bgVideo.pause(); } catch (e) {} }
        videoHost.innerHTML = '<iframe src="https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
        modal.hidden = false;
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
      }
      function closeModal() {
        modal.classList.remove('is-open');
        setTimeout(function () {
          modal.hidden = true;
          /* Tear down the iframe FIRST so it releases media focus, then
             resume the background video. */
          videoHost.innerHTML = '';
          if (bgVideo) { bgVideo.play().catch(function () {}); }
        }, 300);
      }
      launchBtn.addEventListener('click', openModal);
      /* Any click bubbling to the modal is outside the YouTube iframe
         (cross-origin clicks don't escape), so a single handler closes
         on backdrop/frame border/close button alike. */
      modal.addEventListener('click', closeModal);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
      });
    }
  }

  function initPuzzle() {
    var section = document.querySelector('[data-gr-puzzle]');
    if (!section) return;
    var cards = section.querySelectorAll('[data-gr-puzzle-card]');
    var minis = section.querySelectorAll('[data-gr-puzzle-mini]');
    var chain = section.querySelector('.gr-puzzle__chain');
    if (!cards.length || !minis.length) return;

    /* Mobile stacks intro → cards → chain, so minis live AFTER the cards.
       Decouple their reveal from the card observers and trigger them when
       the chain scrolls into view instead. */
    var isMobile = window.matchMedia('(max-width: 899px)').matches;

    /* Fraction of viewport height (from bottom) where the reveal triggers. */
    var STROKE_T = 0.45;

    /* pathLength on <use> isn't reliable — measure the real outline length
       and hand it to CSS via a custom prop. */
    for (var i = 0; i < minis.length; i++) {
      var shape = minis[i].querySelector('defs path');
      var revealEl = minis[i].querySelector('.gr-puzzle__reveal');
      if (shape && revealEl) {
        revealEl.style.setProperty('--gr-puzzle-path-len', shape.getTotalLength());
      }
    }

    /* Apply correct phase classes synchronously based on current scroll,
       before transitions are enabled — prevents flash-of-animation when
       the page loads already scrolled into or past the section. */
    var vh = window.innerHeight;
    for (var j = 0; j < cards.length; j++) {
      var cardTop = cards[j].getBoundingClientRect().top;
      if (cardTop <= vh * (1 - STROKE_T)) {
        cards[j].classList.add('is-stroke-in');
        if (!isMobile) minis[j].classList.add('is-stroke-in');
      }
    }
    void section.offsetWidth;
    section.classList.add('is-ready');

    /* Card observer: drives the card badge reveal on every viewport. On
       desktop it also drives the matching mini piece. */
    var cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var idx = parseInt(entry.target.getAttribute('data-gr-puzzle-card'), 10);
        var passed = entry.isIntersecting || entry.boundingClientRect.top <= 0;
        entry.target.classList.toggle('is-stroke-in', passed);
        if (!isMobile && minis[idx]) {
          minis[idx].classList.toggle('is-stroke-in', passed);
        }
      });
    }, {
      rootMargin: '0px 0px -' + (STROKE_T * 100) + '% 0px',
      threshold: 0
    });
    cards.forEach(function (card) { cardObserver.observe(card); });

    /* Mobile only: reveal the chain's minis when the chain itself enters
       view, so the draw-in animation plays as the user reaches it. */
    if (isMobile && chain) {
      var chainObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting || entry.boundingClientRect.top <= 0) {
            for (var m = 0; m < minis.length; m++) {
              (function (mini, delay) {
                setTimeout(function () { mini.classList.add('is-stroke-in'); }, delay);
              })(minis[m], m * 350);
            }
            chainObserver.disconnect();
          }
        });
      }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });
      chainObserver.observe(chain);
    }
  }

  function initTabs(container, tabAttr, panelAttr) {
    tabAttr = tabAttr || 'data-gr-tab';
    panelAttr = panelAttr || 'data-gr-panel';
    var tabs = container.querySelectorAll('[' + tabAttr + ']');
    var panels = container.querySelectorAll('[' + panelAttr + ']');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute(tabAttr);
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute(panelAttr) === idx);
        });
      });
    });
  }

  /* Sync the compounds scale slide-window height to the active slide so the
     container grows/shrinks smoothly when switching tabs. The horizontal
     slide translate is handled by CSS :has(). */
  function initCompoundsScale() {
    document.querySelectorAll('[data-gr-scale]').forEach(function (scale) {
      var win = scale.querySelector('.gr-scale__slide-window');
      var track = scale.querySelector('.gr-scale__slide-track');
      if (!win || !track) return;
      var slides = track.children;
      var grid = scale.closest('.gr-compounds__grid');

      function updateHeight() {
        if (!grid) return;
        var active = grid.querySelector('.gr-compounds__info-panel.is-active');
        var idx = active ? parseInt(active.getAttribute('data-gr-panel'), 10) : 0;
        var slide = slides[idx];
        if (!slide) return;
        var next = slide.offsetHeight + 'px';
        if (win.style.height !== next) win.style.height = next;
      }

      updateHeight();

      function resolveMarkers() {
        scale.querySelectorAll('.gr-scale__markers').forEach(function (row) {
          var m1 = row.querySelector('.gr-scale__marker--1');
          var m2 = row.querySelector('.gr-scale__marker--2');
          if (!m1 || !m2) return;
          m1.style.setProperty('--shift', '0px');
          m2.style.setProperty('--shift', '0px');
          var r1 = m1.getBoundingClientRect();
          var r2 = m2.getBoundingClientRect();
          var minGap = 40;
          var c1 = r1.left + r1.width / 2;
          var c2 = r2.left + r2.width / 2;
          var leftEl = c1 <= c2 ? m1 : m2;
          var rightEl = leftEl === m1 ? m2 : m1;
          var leftRect = leftEl === m1 ? r1 : r2;
          var rightRect = leftEl === m1 ? r2 : r1;
          var overlap = (leftRect.right + minGap) - rightRect.left;
          if (overlap <= 0) return;
          var half = overlap / 2;
          leftEl.style.setProperty('--shift', (-half) + 'px');
          rightEl.style.setProperty('--shift', half + 'px');
        });
      }

      resolveMarkers();
      var section = scale.closest('.gr-compounds');
      if (section) {
        section.querySelectorAll('.gr-tabs__tab').forEach(function (tab) {
          tab.addEventListener('click', function () {
            requestAnimationFrame(function () { updateHeight(); resolveMarkers(); });
          });
        });
      }
      window.addEventListener('resize', function () { updateHeight(); resolveMarkers(); }, { passive: true });
    });
  }

  /* Chart.js loads lazily on first Radar sub-tab click. */
  function initCasingRadar() {
    var section = document.querySelector('.gr-casings');
    if (!section) return;
    var canvas = section.querySelector('[data-gr-radar]');
    if (!canvas) return;

    var labels = ['GRIP', ['CORNERING', 'SUPPORT'], ['FLAT', 'PROTECTION'], ['COMFORT /', 'DAMPING'], ['TREAD', 'LIFE'], ['ROLLING', 'SPEED'], 'BRAKING'];
    /* Index matches casing tab order: 0 Flux AM · 1 Flux GR · 2 Flux GR Radial */
    var casingData = [
      { mopo: [4.5, 4, 4, 5, 4, 4.5, 4.5], momentum: [4.5, 4, 4.5, 4.5, 5, 4.5, 4.5] },
      { mopo: [4.5, 5, 5, 4.5, 4, 3.5, 4.5], momentum: [4, 5, 5, 4.5, 5, 4, 4] },
      { mopo: [5, 5, 5, 5, 3.5, 3.5, 5], momentum: [4.5, 5, 5, 4.5, 4.5, 4, 4.5] }
    ];

    /* Bend the radial scale so rings bunch toward the center and spread near
       the edge — Chart.js doesn't expose a built-in way to deform the scale,
       so we monkey-patch the distance function after layout. Both grid-ring
       draw and data draw call this method, keeping them aligned. */
    var expRadialPlugin = {
      id: 'grExpRadial',
      afterLayout: function (chart) {
        var scale = chart.scales && chart.scales.r;
        if (!scale || scale._grExpPatched) return;
        scale._grExpPatched = true;
        scale.getDistanceFromCenterForValue = function (value) {
          var span = this.max - this.min;
          if (!span) return 0;
          var n = (value - this.min) / span;
          if (n < 0) n = 0; else if (n > 1) n = 1;
          return this.drawingArea * Math.pow(n, 1.8);
        };
      }
    };

    var chart = null;
    var lastIdx = -1;

    function activeCasingIdx() {
      var active = section.querySelector('.gr-tabs__panel.is-active');
      return active ? (parseInt(active.getAttribute('data-gr-panel'), 10) || 0) : 0;
    }

    function createChart() {
      var idx = activeCasingIdx();
      if (!casingData[idx]) idx = 0;
      lastIdx = idx;
      chart = new Chart(canvas, {
        type: 'radar',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'MoPo',
              data: casingData[idx].mopo,
              borderColor: '#c4262e',
              backgroundColor: 'rgba(196, 38, 46, 0.15)',
              pointBackgroundColor: '#c4262e',
              pointBorderColor: '#c4262e',
              borderWidth: 2
            },
            {
              label: 'Momentum',
              data: casingData[idx].momentum,
              borderColor: '#97d5ca',
              backgroundColor: 'rgba(151, 213, 202, 0.15)',
              pointBackgroundColor: '#97d5ca',
              pointBorderColor: '#97d5ca',
              borderWidth: 2
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: { duration: 400, easing: 'easeOutQuart' },
          scales: {
            r: {
              min: 0,
              max: 5,
              ticks: {
                stepSize: 0.5,
                display: false
              },
              grid: {
                color: function (ctx) {
                  return (ctx.index % 2 === 0)
                    ? 'rgba(255, 255, 255, 0.22)'
                    : 'rgba(255, 255, 255, 0.08)';
                },
                lineWidth: 1,
                circular: true
              },
              angleLines: { color: 'rgba(255, 255, 255, 0.18)', lineWidth: 1 },
              pointLabels: {
                color: 'rgba(255, 255, 255, 0.85)',
                font: { family: 'Tofino, arial, sans-serif', size: 10, weight: '700' },
                padding: 10
              }
            }
          },
          plugins: { legend: { display: false } },
          elements: {
            line: { borderWidth: 2 },
            point: { radius: 3, hoverRadius: 5 }
          }
        },
        plugins: [expRadialPlugin]
      });
    }

    function updateChart() {
      if (!chart) return;
      var idx = activeCasingIdx();
      if (idx === lastIdx || !casingData[idx]) return;
      lastIdx = idx;
      chart.data.datasets[0].data = casingData[idx].mopo;
      chart.data.datasets[1].data = casingData[idx].momentum;
      chart.update();
    }

    function ensureChart() {
      if (chart || typeof Chart !== 'undefined') {
        if (!chart) createChart();
        return;
      }
      var existing = document.querySelector('script[data-gr-chartjs]');
      if (existing) {
        existing.addEventListener('load', createChart);
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/chart.js';
      script.setAttribute('data-gr-chartjs', '');
      script.onload = createChart;
      document.head.appendChild(script);
    }

    var radarTab = section.querySelector('[data-gr-vistab="radar"]');
    if (radarTab) radarTab.addEventListener('click', ensureChart);

    var mainTabs = section.querySelector('[data-gr-tabs] .gr-tabs')
      || section.querySelector('.gr-tabs');
    if (mainTabs) {
      mainTabs.querySelectorAll('.gr-tabs__tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (!chart) return;
          requestAnimationFrame(updateChart);
        });
      });
    }
  }

  /* Scroll-snap track + timed pill progress + play/pause. Pill fill is a CSS
     animation (animation-play-state: paused for freeze). Timer is a single
     setTimeout that advances slides. On reaching the last slide, auto-advance
     stops — pressing play loops back to slide 0. Any user interaction freezes
     the timer; it resumes 1s later from the start of the current slide. */
  function initHighlights() {
    document.querySelectorAll('[data-gr-highlights]').forEach(function (section) {
      var track = section.querySelector('[data-gr-highlights-track]');
      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-gr-highlights-slide]'));
      var pills = Array.prototype.slice.call(section.querySelectorAll('[data-gr-highlights-pill]'));
      var playBtn = section.querySelector('[data-gr-highlights-play]');
      if (!track || !slides.length) return;

      var current = 0;
      var total = slides.length;
      var playing = true;
      var visible = false;
      var atEnd = false;
      var advanceTimer = null;
      var resumeTimer = null;
      var programmatic = false;
      var programmaticTimer = null;

      function slideDurationMs(idx) {
        var d = parseFloat(slides[idx].getAttribute('data-gr-highlights-duration'));
        return (d && d > 0) ? d * 1000 : 6000;
      }

      function syncVideos() {
        slides.forEach(function (slide, i) {
          var v = slide.querySelector('video');
          if (!v) return;
          if (!v.dataset.grEndBound) {
            v.dataset.grEndBound = '1';
            v.addEventListener('ended', function () {
              var idx = slides.indexOf(slide);
              if (idx !== current) return;
              clearAdvance();
              if (current >= total - 1) {
                atEnd = true;
                goTo(0);
                setPlaying(false);
                return;
              }
              goTo(current + 1);
            });
          }
          if (i === current && playing && visible && !section.classList.contains('is-interacting')) {
            v.muted = true;
            v.defaultMuted = true;
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }

      function startFill() {
        /* Remove is-timing from all pills, force reflow on the active one,
           then re-add — this restarts the CSS animation from scaleX(0). */
        pills.forEach(function (p) { p.classList.remove('is-timing'); });
        var active = pills[current];
        if (!active) return;
        var slide = slides[current];
        var v = slide && slide.querySelector('video');
        if (v) {
          var startWhenPlaying = function () {
            v.removeEventListener('playing', startWhenPlaying);
            if (current !== slides.indexOf(slide)) return;
            if (v.duration && isFinite(v.duration) && v.duration > 0) {
              active.style.setProperty('--gr-duration', v.duration + 's');
            }
            void active.offsetWidth;
            active.classList.add('is-timing');
          };
          v.addEventListener('playing', startWhenPlaying);
        } else {
          void active.offsetWidth;
          active.classList.add('is-timing');
        }
      }

      function stopFill() {
        pills.forEach(function (p) { p.classList.remove('is-timing'); });
      }

      function clearAdvance() {
        clearTimeout(advanceTimer);
        advanceTimer = null;
      }

      function scheduleAdvance() {
        clearAdvance();
        if (!playing || !visible || section.classList.contains('is-interacting')) return;
        if (slides[current] && slides[current].querySelector('video')) return;
        advanceTimer = setTimeout(function () {
          if (current >= total - 1) {
            atEnd = true;
            setPlaying(false);
            return;
          }
          goTo(current + 1);
        }, slideDurationMs(current));
      }

      function scrollToSlide(idx) {
        var slide = slides[idx];
        if (!slide) return;
        var trackLeft = track.getBoundingClientRect().left;
        var slideLeft = slide.getBoundingClientRect().left;
        var offset = slideLeft - trackLeft + track.scrollLeft - (track.offsetWidth - slide.offsetWidth) / 2;
        programmatic = true;
        clearTimeout(programmaticTimer);
        programmaticTimer = setTimeout(function () { programmatic = false; }, 700);
        track.scrollTo({ left: offset, behavior: 'smooth' });
      }

      function setActive(idx) {
        current = idx;
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === idx);
          s.classList.toggle('is-ended', i !== idx);
          if (i === idx) {
            var v = s.querySelector('video');
            if (v) { try { v.currentTime = 0; } catch (e) {} }
          }
        });
        pills.forEach(function (p, i) { p.classList.toggle('is-active', i === idx); });
        atEnd = false;
      }

      function goTo(idx) {
        if (idx < 0) idx = 0;
        if (idx >= total) idx = total - 1;
        setActive(idx);
        scrollToSlide(idx);
        if (playing && visible) { startFill(); scheduleAdvance(); }
        syncVideos();
      }

      function setPlaying(val) {
        playing = val;
        section.classList.toggle('is-paused', !val);
        if (playBtn) playBtn.setAttribute('aria-label', val ? 'Pause slideshow' : 'Play slideshow');
        if (val) {
          if (atEnd) { atEnd = false; goTo(0); return; }
          if (visible) {
            var activePill = pills[current];
            var slide = slides[current];
            var hasVideo = slide && slide.querySelector('video');
            if (!(hasVideo && activePill && activePill.classList.contains('is-timing'))) {
              startFill();
            }
            scheduleAdvance();
          }
        } else {
          clearAdvance();
          var slidePaused = slides[current];
          var hasVideoPaused = slidePaused && slidePaused.querySelector('video');
          if (!hasVideoPaused) stopFill();
        }
        syncVideos();
      }

      /* User interaction: freeze progress + timer; resume 1s after last event.
         Resume restarts the fill from the start of the current slide rather
         than trying to carry partial progress — simpler, less bug-prone. */
      function beginInteract() {
        section.classList.add('is-interacting');
        clearAdvance();
        clearTimeout(resumeTimer);
        syncVideos();
      }
      function endInteract() {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          section.classList.remove('is-interacting');
          if (playing && visible) { startFill(); scheduleAdvance(); }
          syncVideos();
        }, 1000);
      }

      var scrollTicking = false;
      function syncFromScroll() {
        if (programmatic) return;
        var rect = track.getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var closest = current;
        var closestDist = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var sr = slides[i].getBoundingClientRect();
          var d = Math.abs(sr.left + sr.width / 2 - center);
          if (d < closestDist) { closestDist = d; closest = i; }
        }
        if (closest !== current) {
          setActive(closest);
          syncVideos();
          /* Treat scroll-driven changes as user interaction — the timer
             resumes on the new slide 1s after scroll settles. */
          beginInteract();
          endInteract();
        }
      }
      track.addEventListener('scroll', function () {
        if (!scrollTicking) {
          requestAnimationFrame(function () { syncFromScroll(); scrollTicking = false; });
          scrollTicking = true;
        }
      }, { passive: true });

      track.addEventListener('pointerdown', beginInteract);
      track.addEventListener('pointerup', endInteract);
      track.addEventListener('pointercancel', endInteract);

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var idx = parseInt(pill.getAttribute('data-gr-highlights-pill'), 10);
          if (isNaN(idx)) return;
          beginInteract();
          goTo(idx);
          endInteract();
        });
      });

      slides.forEach(function (slide, i) {
        slide.addEventListener('click', function (e) {
          if (i === current) return;
          e.preventDefault();
          e.stopPropagation();
          beginInteract();
          goTo(i);
          endInteract();
        }, true);
      });

      if (playBtn) playBtn.addEventListener('click', function () { setPlaying(!playing); });

      /* Don't activate until the carousel itself is essentially fully in view
         — 90% of the slide area visible. The section is usually taller than
         the viewport (header + slide + controls), so observing the whole
         section with threshold:1 would never fire; observing the carousel
         (which fits the viewport) with a high threshold does the right thing. */
      var obsTarget = section.querySelector('.gr-highlights__carousel') || section;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var wasVisible = visible;
          visible = entry.intersectionRatio >= 0.99;
          if (visible && !wasVisible) {
            if (playing) { startFill(); scheduleAdvance(); }
            syncVideos();
          } else if (!visible && wasVisible) {
            clearAdvance();
            stopFill();
            syncVideos();
          }
        });
      }, { threshold: [0, 0.5, 0.99, 1] }).observe(obsTarget);

      /* setTimeout keeps firing when the tab is backgrounded; without this
         the slideshow silently advances past every slide. */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          clearAdvance();
          stopFill();
          syncVideos();
        } else if (playing && visible) {
          startFill();
          scheduleAdvance();
          syncVideos();
        }
      });

      setActive(0);
      syncVideos();
    });
  }

  /* Setup: 2×2 cards morph into a 1×4 tab row when one is clicked, while a
     detail carousel below opens with the matching panel sliding in from the
     right. Clicking another tab slides the current panel out left and the
     new one in from the right. */
  function initSetup() {
    document.querySelectorAll('[data-gr-setup-stage]').forEach(function (stage) {
      var cards = Array.prototype.slice.call(stage.querySelectorAll('[data-gr-setup-card]'));
      if (!cards.length) return;

      var detailFrame = stage.querySelector('[data-gr-detail-frame]');
      var panels = detailFrame
        ? Array.prototype.slice.call(detailFrame.querySelectorAll('[data-gr-detail]'))
        : [];

      var currentIdx = -1;
      var heightObserver = null;
      var settleTimer = null;

      function syncDetailHeight() {
        if (!detailFrame || currentIdx < 0) return;
        var p = panels[currentIdx];
        if (!p) return;
        detailFrame.style.setProperty('--gr-detail-h', p.offsetHeight + 'px');
      }

      function activate(newIdx) {
        if (newIdx === currentIdx) return;
        var isFirstOpen = currentIdx === -1;

        clearTimeout(settleTimer);
        cards.forEach(function (c, i) {
          c.classList.remove('is-settled');
          c.classList.toggle('is-active', i === newIdx);
        });

        /* Mobile carousel: snap the tapped card to its start (left edge). */
        if (window.matchMedia('(max-width: 899px)').matches && cards[newIdx]) {
          cards[newIdx].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        }

        /* Defer the line-screen overlay until the heaviest layout work
           has settled — keeps the open animation smoother. */
        var newCard = cards[newIdx];
        settleTimer = setTimeout(function () {
          if (newCard && newCard.classList.contains('is-active')) {
            newCard.classList.add('is-settled');
          }
        }, 450);

        panels.forEach(function (p, i) {
          if (i === newIdx) {
            /* First open: panel stays at default (no transform), just
               fades in. Tab swap: snap panel off-right via .is-incoming
               with transitions disabled, then add .is-active so it
               slides in from the right. */
            if (isFirstOpen) {
              p.classList.remove('is-out', 'is-incoming');
              p.classList.add('is-active');
            } else {
              p.style.transition = 'none';
              p.classList.remove('is-out', 'is-active');
              p.classList.add('is-incoming');
              void p.offsetWidth;
              p.style.transition = '';
              p.classList.remove('is-incoming');
              p.classList.add('is-active');
            }
          } else if (p.classList.contains('is-active')) {
            p.classList.remove('is-active');
            if (!isFirstOpen) p.classList.add('is-out');
          }
        });

        stage.classList.add('is-expanded');
        currentIdx = newIdx;
        /* Re-target the height observer to the new active panel — only
           one panel is visible at a time, so observing the others fires
           callbacks that are immediately discarded. */
        if (heightObserver) {
          heightObserver.disconnect();
          if (panels[newIdx]) heightObserver.observe(panels[newIdx]);
        }
        /* Sync after a tick so the new panel's layout is settled. */
        requestAnimationFrame(syncDetailHeight);
      }

      function closeAll() {
        clearTimeout(settleTimer);
        if (heightObserver) heightObserver.disconnect();
        cards.forEach(function (c) {
          c.classList.remove('is-active', 'is-settled');
        });
        panels.forEach(function (p) {
          p.classList.remove('is-active', 'is-out', 'is-incoming');
        });
        stage.classList.remove('is-expanded');
        if (detailFrame) detailFrame.style.removeProperty('--gr-detail-h');
        currentIdx = -1;
      }

      cards.forEach(function (card, i) {
        card.addEventListener('click', function () {
          if (i === currentIdx) return;
          activate(i);
        });
      });

      stage.querySelectorAll('[data-gr-setup-close]').forEach(function (close) {
        close.addEventListener('click', function (e) {
          e.stopPropagation();
          closeAll();
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && stage.classList.contains('is-expanded')) closeAll();
      });

      /* Mobile carousel sync: when the user swipes/scrolls the cards row
         and the detail panel is open, whichever card lands centered after
         the scroll settles becomes the active section. */
      var cardsContainer = stage.querySelector('.gr-setup__cards');
      if (cardsContainer && cards.length > 1) {
        var scrollSettleTimer = null;
        var onScrollSettle = function () {
          if (!stage.classList.contains('is-expanded')) return;
          var containerRect = cardsContainer.getBoundingClientRect();
          var containerCenter = containerRect.left + containerRect.width / 2;
          var nearestIdx = -1;
          var minDist = Infinity;
          cards.forEach(function (c, i) {
            var rect = c.getBoundingClientRect();
            var dist = Math.abs(rect.left + rect.width / 2 - containerCenter);
            if (dist < minDist) {
              minDist = dist;
              nearestIdx = i;
            }
          });
          if (nearestIdx >= 0 && nearestIdx !== currentIdx) {
            activate(nearestIdx);
          }
        };
        if ('onscrollend' in window) {
          cardsContainer.addEventListener('scrollend', onScrollSettle);
        } else {
          cardsContainer.addEventListener('scroll', function () {
            clearTimeout(scrollSettleTimer);
            scrollSettleTimer = setTimeout(onScrollSettle, 120);
          }, { passive: true });
        }
      }

      /* Watch only the currently-active panel for content-driven height
         changes (tab swaps inside it, font load, variant size reflow).
         The active target is rebound by activate(). */
      if (typeof ResizeObserver !== 'undefined' && panels.length) {
        heightObserver = new ResizeObserver(syncDetailHeight);
      }
    });
    initSetupShop();
  }

  /* Tire shop behavior: size radios swap variant + price + image + ATC id;
     "Add Set" sends front + rear in one request. Per-panel total recomputes
     when sizes change. */
  function initSetupShop() {
    function formatMoney(cents, format) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        try { return Shopify.formatMoney(cents, format || Shopify.money_format); } catch (e) {}
      }
      if (!format) return (cents / 100).toFixed(2);
      var amount = cents / 100;
      function thousands(value, sep) {
        var parts = value.split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sep);
        return parts.join('.');
      }
      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
        var n;
        if (key === 'amount_no_decimals_with_comma_separator') {
          n = thousands(Math.round(amount).toFixed(0), '.');
        } else if (key === 'amount_no_decimals_with_space_separator') {
          n = thousands(Math.round(amount).toFixed(0), ' ');
        } else if (key === 'amount_with_comma_separator') {
          n = thousands(amount.toFixed(2), '.').replace(/\.(\d{2})$/, ',$1');
        } else if (key === 'amount_with_space_separator') {
          n = thousands(amount.toFixed(2), ' ').replace(/\.(\d{2})$/, ',$1');
        } else if (key === 'amount_with_apostrophe_separator') {
          n = thousands(amount.toFixed(2), "'");
        } else if (key === 'amount_no_decimals') {
          n = thousands(Math.round(amount).toFixed(0), ',');
        } else {
          n = thousands(amount.toFixed(2), ',');
        }
        return n;
      });
    }

    function updatePanelTotal(panel) {
      if (!panel) return;
      var setBtn = panel.querySelector('[data-gr-add-both]');
      if (!setBtn) return;
      var totalEl = setBtn.querySelector('[data-gr-set-total]');
      var tires = panel.querySelectorAll('[data-gr-tire]');
      var total = 0;
      var allAvail = tires.length > 0;
      tires.forEach(function (tire) {
        var atc = tire.querySelector('[data-gr-tire-atc]');
        var cents = parseInt(tire.getAttribute('data-gr-tire-cents') || '0', 10);
        total += isNaN(cents) ? 0 : cents;
        if (!atc || atc.disabled) allAvail = false;
      });
      if (totalEl) {
        totalEl.setAttribute('data-gr-set-cents', String(total));
        totalEl.textContent = formatMoney(total, setBtn.getAttribute('data-gr-money-format'));
      }
      setBtn.disabled = !allAvail;
    }

    function addToCart(items, btn) {
      var labelEl = btn.querySelector('[data-gr-btn-label]') || btn;
      var originalText = labelEl.textContent;
      labelEl.textContent = 'Adding…';
      btn.disabled = true;
      var cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var sectionsToRender = cartDrawer && cartDrawer.getSectionsToRender
        ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
        : [];
      var body = { items: items };
      if (sectionsToRender.length) {
        body.sections = sectionsToRender.join(',');
        body.sections_url = window.location.pathname;
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) { return res.json(); })
        .then(function (response) {
          if (response.status && response.status >= 400) {
            labelEl.textContent = originalText;
            btn.disabled = false;
            return;
          }
          labelEl.textContent = 'Added ✓';
          btn.disabled = false;
          try {
            if (cartDrawer && cartDrawer.renderContents && response.sections) {
              cartDrawer.renderContents(response);
            }
          } catch (e) {}
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gr-setup', productVariantId: items[0].id });
            }
          } catch (e) {}
          setTimeout(function () { labelEl.textContent = originalText; }, 2000);
        })
        .catch(function () {
          labelEl.textContent = 'Error';
          btn.disabled = false;
          setTimeout(function () { labelEl.textContent = originalText; }, 3000);
        });
    }

    document.querySelectorAll('[data-gr-tire]').forEach(function (tire) {
      var json = tire.querySelector('[data-gr-tire-variants]');
      var radios = tire.querySelectorAll('[data-gr-tire-size]');
      var atc = tire.querySelector('[data-gr-tire-atc]');
      var atcLabel = atc && atc.querySelector('[data-gr-btn-label]');
      var priceEl = tire.querySelector('[data-gr-tire-price]');
      var skuEl = tire.querySelector('[data-gr-tire-sku]');
      var imgEl = tire.querySelector('[data-gr-tire-img]');
      var position = tire.getAttribute('data-gr-tire-position') || 'tire';
      var positionLabel = position.charAt(0).toUpperCase() + position.slice(1);
      if (!json || !atc) return;

      var variants = [];
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          var vid = parseInt(radio.value, 10);
          var match = null;
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].id === vid) { match = variants[i]; break; }
          }
          if (!match) return;
          atc.setAttribute('data-gr-tire-atc', match.id);
          tire.setAttribute('data-gr-tire-cents', String(match.priceCents || 0));
          if (priceEl && match.price) priceEl.textContent = match.price;
          if (skuEl) skuEl.textContent = match.sku || '';
          if (imgEl && match.image) imgEl.src = match.image;
          atc.disabled = !match.available;
          if (atcLabel) {
            atcLabel.textContent = match.available ? ('Add ' + positionLabel + ' to Cart') : 'Sold Out';
          }
          tire.querySelectorAll('.gr-setup__size-btn').forEach(function (btn) {
            var input = btn.querySelector('input');
            btn.classList.toggle('is-active', input === radio);
          });
          updatePanelTotal(tire.closest('[data-gr-option]'));
        });
      });

      atc.addEventListener('click', function (e) {
        e.stopPropagation();
        var id = parseInt(atc.getAttribute('data-gr-tire-atc'), 10);
        if (!id) return;
        addToCart([{ id: id, quantity: 1 }], atc);
      });
    });

    document.querySelectorAll('[data-gr-add-both]').forEach(function (btn) {
      var panel = btn.closest('[data-gr-option]');
      if (!panel) return;
      var tires = panel.querySelectorAll('[data-gr-tire]');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var items = [];
        tires.forEach(function (tire) {
          var atc = tire.querySelector('[data-gr-tire-atc]');
          if (!atc || atc.disabled) return;
          var id = parseInt(atc.getAttribute('data-gr-tire-atc'), 10);
          if (id) items.push({ id: id, quantity: 1 });
        });
        if (!items.length) return;
        addToCart(items, btn);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-gr-tabs]').forEach(function (c) { initTabs(c); });
    document.querySelectorAll('[data-gr-vistabs]').forEach(function (c) {
      initTabs(c, 'data-gr-vistab', 'data-gr-vispanel');
    });
    initCompoundsScale();
    initCasingRadar();
    initWordmark();
    initPuzzle();
    initHighlights();
    initSetup();
    measureTopOffset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Fonts swap late and can change the header's height; resize fires
     continuously on mobile as the address bar collapses. */
  window.addEventListener('load', scheduleTopOffset);
  window.addEventListener('resize', scheduleTopOffset, { passive: true });
})();
